<template>
    <div class="account" v-loading="loading">
        <div class="account-first">
            <div class="account-first-view">
                <div class="account-first-list">
                    <div class="first-list-block" v-for="(item, index) in 5" :key="index">
                        <div class="list-block-title">
                            {{
        index == 0
            ? '用户id'
            : index == 1
                ? '用户昵称'
                : index == 2
                    ? '合伙人手机号'
                    : index == 3
                        ? 'id状态'
                        : index == 4
                            ? '创建时间'
                            : ''
    }}
                        </div>
                        <div class="list-block-input">
                            <el-input v-if="index == 0" v-model="partnerId" clearable placeholder="请输入用户id"></el-input>

                            <el-input v-if="index == 1" v-model="partnerName" clearable
                                placeholder="请输入用户昵称"></el-input>

                            <el-input v-if="index == 2" v-model="partnerPhone" clearable
                                placeholder="请输入合伙人手机号"></el-input>

                            <el-select v-if="index == 3" v-model="partnerIdstatus" clearable placeholder="请选择">
                                <el-option v-for="item in partnerIdOptions" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>

                            <el-date-picker v-if="index == 4" value-format="yyyy-MM-dd" v-model="partnerPaymentTime"
                                type="daterange" range-separator start-placeholder="开始日期"
                                end-placeholder="结束日期"></el-date-picker>
                        </div>
                    </div>
                </div>

                <div class="account-first-button">
                    <div class="account-first-button-left" @click="accountInquire">
                        查询
                    </div>
                    <div class="account-first-button-right" @click="accountReset">
                        重置
                    </div>
                </div>
            </div>
        </div>

        <div class="account-second">
            <div class="account-second-div">
                <div class="account-second-div-left">查询结果</div>
                <div class="account-second-div-right">
                    <div class="account-second-div-right-refresh" @click="refreshClick">
                        刷新
                    </div>
                    <div class="account-second-div-right-derive" @click="deriveClick">
                        <img class="account-second-div-right-derive-img" src="../../assets/common/common-derive.png" />
                        <div class="account-second-div-right-derive-text">导出订单</div>
                    </div>
                </div>
            </div>

            <div class="account-second-table">
                <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" border=""
                    @selection-change="handleSelectionChange" :header-cell-style="{
        color: '#333333',
        backgroundColor: '#FAFAFA',
    }">
                    <!-- 自定义暂无数据 -->
                    <template slot="empty">
                        <div class="empty-block">
                            <img class="empty-block-img" src="../../assets/common/common-empty.png" />
                            <div class="empty-block-text">暂无数据～</div>
                        </div>
                    </template>
                    <el-table-column type="selection" width="45"></el-table-column>
                    <el-table-column prop="userId" label="用户id" width="100px">
                    </el-table-column>

                    <el-table-column prop="username" label="用户名称">
                    </el-table-column>
                    <el-table-column prop="nickname" label="合伙人姓名">
                    </el-table-column>

                    <el-table-column prop="IDNumber" label="合伙人身份证号" width="250">
                    </el-table-column>

                    <el-table-column prop="userPhone" label="合伙人手机号">
                    </el-table-column>

                    <el-table-column prop="depositMoney" label="合伙人保证金">
                    </el-table-column>



                    <el-table-column label="合伙人审核状态">

                        <template slot-scope="scope">
                            <div class="table-userStatus" :style="{
        color:
            scope.row.status == -2 || scope.row.status == -2 ? '#FF3333' : scope.row.status == -1 ? '#FF3333' : scope.row.status == 0 ? '#999999' : scope.row.status == 1 ? '#36C100' : ''
    }">
                                {{
        scope.row.status == -3 ? '已驳回' : scope.row.status == -2 ? '待审核' : scope.row.status == -1
            ?
            '禁止' : scope.row.status == 0 ?
                '失效' : scope.row.status == 1 ? '生效' : ''
    }}
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column prop="createTime" label="创建时间" width="160">
                    </el-table-column>

                    <el-table-column label="操作" width="150">

                        <template slot-scope="scope">
                            <div class="table-operation">
                                <div class="table-operation-left" @click="forbiddenBtn(scope.row, 0)">
                                    同意
                                </div>

                                <div class="table-operation-left" @click="forbiddenBtn(scope.row, 1)">
                                    拒绝
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="account-second-Pagination">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :page-sizes="[10, 20, 30, 40]" :page-size="10" layout="prev, pager, next, sizes"
                    :total="totalNum"></el-pagination>
            </div>
        </div>


        <!--第二区域  进行禁用-->
        <div class="examine">
            <el-dialog :visible.sync="examineDialogVisible" style="margin-top: 10vh" @close="examineCancel">
                <span slot="footer" class="dialog-footer">
                    <div class="examine-password">
                        <div class="password">
                            <img class="password-img" src="../../assets/common/common-warning.png" />
                        </div>

                        <div class="title" v-if="examineIndex == 0">是否同意该账户成为合伙人？
                        </div>
                        <div class="title" v-if="examineIndex == 1">是否拒绝该账户成为合伙人？</div>


                        <div class="text" v-if="examineIndex == 0">一旦确定将同意成为合伙人
                        </div>
                        <div class="text" v-if="examineIndex == 1">一旦确定将拒绝成为合伙人</div>
                    </div>

                    <div class="examine-button">
                        <div class="examine-button-left" @click="examineConfirm">
                            确定
                        </div>
                        <div class="examine-button-right" @click="examineCancel">
                            取消
                        </div>
                    </div>
                </span>
            </el-dialog>
        </div>

        <!--第二区域 查看密码-->
        <div class="password">
            <el-dialog :visible.sync="passwordDialogVisible" style="margin-top: 10vh" @close="passwordCancel">
                <span slot="footer" class="dialog-footer">
                    <div class="password-title">
                        <div class="title">合伙人id账号密码</div>
                        <img @click="passwordCancel" class="img" src="../../assets/common/close.png" alt="" />
                    </div>

                    <div class="password-block">
                        <div class="password-block-title">合伙人账号</div>
                        <div class="password-block-span">{{ passwordObj.userPhone }}</div>
                    </div>

                    <div class="password-block">
                        <div class="password-block-title">合伙人密码</div>
                        <div class="password-block-span">{{ passwordObj.proclaimedPassword }}</div>
                    </div>
                </span>
            </el-dialog>
        </div>

        <div class="information">
            <el-dialog :visible.sync="informationDialogVisible" @close="informationCancel">
                <span slot="footer" class="dialog-footer">
                    <div class="information-title">
                        <div class="title">合伙人账号审核</div>
                        <img @click="informationCancel" class="img" src="../../assets/common/close.png" alt="" />
                    </div>

                    <div class="information-block">
                        <div class="block-select">
                            <div class="select-title">审核状态</div>
                            <div class="select">
                                <el-select v-model="alipayValue" clearable placeholder="请选择">
                                    <el-option v-for="item in informationOption" :key="item.index" :label="item.title"
                                        :value="item.index">
                                    </el-option>
                                </el-select>

                            </div>
                        </div>
                    </div>
                    <div class="information-button">
                        <!-- <div class="button-reset" @click="abilityReset">重 置</div> -->
                        <div class="button-confirm" @click="informationConfirm">确 定</div>
                    </div>
                </span>
            </el-dialog>
        </div>

    </div>
</template>

<script>
import { getcollaborateInfo, postupdateCollaborate, getPassword } from '../../api/partenr'

export default {
    data() {
        return {
            // 第一区域
            partnerId: '',
            partnerName: '',
            partnerPhone: '',
            // 用户id状态
            partnerIdstatus: -2,
            partnerIdOptions: [
                {
                    value: -2,
                    label: '待审核',
                },
                {
                    value: -3,
                    label: '已驳回',
                },
            ],
            partnerPaymentTime: [],
            partnerPaymentTimeA: '',
            partnerPaymentTimeB: '',
            // 监听用户刷新
            loading: false,
            // 控制当前页面功能性按钮开关
            accountFunShow: false,
            // 第二区域 表格数组
            tableData: [],
            // 第二区域 表格总条数
            totalNum: 0,
            // 存储表格选中的值
            multipleSelection: [],
            // 页码
            page: 1,
            // 页数
            limit: 10,
            ///-------------------弹出框
            examineDialogVisible: false,
            examineObj: {},
            examineIndex: 0,
            //-----------密码
            passwordDialogVisible: false,
            passwordObj: {},
            //--------------
            informationDialogVisible: false,
            alipayValue: '',
            informationOption: [
                {
                    index: -1,
                    title: '禁止'
                },
                {
                    index: 0,
                    title: '失效'
                },
                {
                    index: 1,
                    title: '生效'
                },
            ],
            accountIndex: 0
        }
    },
    created() {
        this.loading = true
        this.getcollaborateInfoMet()

        setTimeout(() => {
            this.accountFunShow = this.$store.state.pageFunctionShow

        }, 1000);
    },
    methods: {
        getcollaborateInfoMet() {

            let params = {
                userId: this.partnerId,
                userPhone: this.partnerPhone || this.partnerName,
                status: this.partnerIdstatus,
                createStartTime: this.partnerPaymentTimeA,
                createEndTime: this.partnerPaymentTimeB,
                pageNo: this.page,
                pageSize: this.limit
            }

            getcollaborateInfo(params).then(res => {
                if (res.resultStatus == true) {
                    console.log('获取列表数据', res)
                    // 获取表格数组
                    this.tableData = res.resultData.collaborateList
                    // 获取总数
                    this.totalNum = res.resultData.totalNum
                    this.loading = false
                }
            })
        },

        // 第一区域查询
        accountInquire() {
            console.log('触发', this.partnerIdstatus)


            // 订单支付时间
            if (
                this.partnerPaymentTime != null &&
                this.partnerPaymentTime.length != 0
            ) {
                this.partnerPaymentTimeA = this.partnerPaymentTime[0]
                this.partnerPaymentTimeB = this.partnerPaymentTime[1]
            } else {
                this.partnerPaymentTimeA = ''
                this.partnerPaymentTimeB = ''
            }

            this.$nextTick(() => {
                this.getcollaborateInfoMet()
            })
        },
        // 第一区域重置
        accountReset() {
            this.loading = true
            this.partnerId = ''
            this.partnerName = ''
            this.partnerPhone = ''
            this.partnerIdstatus = ''
            this.partnerPaymentTimeA = ''
            this.partnerPaymentTimeB = ''
            this.page = 1

            this.$nextTick(() => {
                this.getcollaborateInfoMet()
            })
        },
        // 刷新当前订单
        refreshClick() {
            this.loading = true
            this.getcollaborateInfoMet()
        },
        // 导出订单
        deriveClick() {
            if (this.accountFunShow == false) {
                this.$message.error('暂无权限！')
                return
            }

            // if (this.marketFunShow == true) {
            //     let commodityIds = this.multipleSelection
            //         .map((item) => {
            //             return item.id
            //         })
            //         .join(';')

            //     let Url =
            //         'https://laravel-api-manager.xmw1688.com/v1/manager/order?excel=' +
            //         1 +
            //         '&ids=' +
            //         commodityIds +
            //         '&userId' +
            //         this.marketUserid +
            //         '&userName=' +
            //         this.marketUsername +
            //         '&userPhone=' +
            //         this.marketUserphone +
            //         '&name=' +
            //         this.marketRecipients +
            //         '&wuliu_num=' +
            //         this.marketLogistics +
            //         '&phone=' +
            //         this.marketRecipientsphone +
            //         '&supplierName=' +
            //         this.marketSuppliername +
            //         '&address=' +
            //         this.marketTake +
            //         '&ordernum=' +
            //         this.marketOrdernum +
            //         '&status=' +
            //         this.marketOrderstatusType +
            //         '&paytype=' +
            //         this.marketPaymentType +
            //         '&createStartTime=' +
            //         this.marketEstablishtimeA +
            //         '&createEndTime=' +
            //         this.marketEstablishtimeB +
            //         '&payStartTime=' +
            //         this.marketPaymentTimeA +
            //         '&payEndTime=' +
            //         this.marketPaymentTimeB +
            //         '&shouStartTime=' +
            //         this.marketOrdertakeA +
            //         '&shouEndTime=' +
            //         this.marketOrdertakeB +
            //         '&paycode=' +
            //         this.marketPaymentNum +
            //         '&activityStatus=' +
            //         this.marketOrderType +
            //         '&accessToken=' +
            //         localStorage.getItem('token')

            //     window.location.href = Url

            //     console.log('查看参数', Url)

            //     this.loading = false
        },

        // 表格区域
        handleSelectionChange(val) {
            this.multipleSelection = val
        },

        //-------------------------
        // 点击禁用
        forbiddenBtn(item, index) {
            if (this.accountFunShow == false) {
                this.$message.error('暂无权限！')
                return
            }

            this.examineIndex = index
            this.accountIndex = index
            this.examineObj = item
            this.examineDialogVisible = true
        },
        //------------------------------
        // 弹出框
        examineConfirm() {
            let params = {
                userId: this.examineObj.userId,
                status: this.accountIndex == 0 ? 1 : -3
            }

            postupdateCollaborate(params).then(res => {
                if (res.resultStatus == true) {
                    this.$message({
                        message: '修改成功！',
                        type: 'success',
                    })
                    this.getcollaborateInfoMet()
                    this.examineDialogVisible = false
                }
            })
        },
        examineCancel() {
            this.examineDialogVisible = false
        },

        // 点击查看id密码
        examineBtn(item) {
            if (this.accountFunShow == false) {
                this.examineIndex = 1
                this.examineDialogVisible = true
                return
            }


            let params = {
                userId: item.userId
            }

            getPassword(params).then(res => {
                if (res.resultStatus == true) {
                    this.passwordObj = res.resultData
                    this.passwordDialogVisible = true
                }
            })

        },
        // 查看密码
        passwordCancel() {
            this.passwordDialogVisible = false
        },

        auditBtn(item) {
            this.alipayValue = item.status
            this.examineObj = item
            this.informationDialogVisible = true
        },
        informationCancel() {
            this.informationDialogVisible = false
        },
        informationConfirm() {

            let params = {
                userId: this.examineObj.userId,
                status: this.alipayValue
            }

            postupdateCollaborate(params).then(res => {
                if (res.resultStatus == true) {
                    this.$message({
                        message: '审核成功！',
                        type: 'success',
                    })
                    this.getcollaborateInfoMet()
                    this.informationDialogVisible = false
                }
            })
        },

        //  查询当前页码多少条
        handleSizeChange(val) {
            this.limit = val
            this.loading = true
            this.getcollaborateInfoMet()
        },
        //  查询当前页
        handleCurrentChange(val) {
            this.page = val
            this.loading = true
            this.getcollaborateInfoMet()
        },

    }
}
</script>

<style lang="less" scoped>
// /deep/ .el-input__inner:focus {
//     border-color: rgba(217, 217, 217, 1);
// }

// /deep/ .el-select .el-input.is-focus .el-input__inner {
//     border-color: rgba(255, 255, 255, 0);
// }

// /deep/ .el-range-editor.is-active,
// .el-range-editor.is-active:hover,
// .el-select .el-input.is-focus .el-input__inner {
//     border-color: rgba(255, 255, 255, 0);
//     border-color: #dcdfe6;
// }

.account {
    .account-first {
        width: 100%;
        height: 180px;
        background: #ffffff;
        box-shadow: 0px 0px 10px 0px #edeff7;
        border-radius: 10px;
        padding: 0 24px;
        display: flex;
        align-items: center;

        .account-first-view {
            .account-first-list {
                display: flex;

                .first-list-block {
                    width: 180px;
                    margin-right: 25px;

                    .list-block-title {
                        height: 17px;
                        font-size: 12px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #333333;
                        line-height: 17px;
                        margin-bottom: 4px;
                    }

                    .list-block-input {
                        width: 180px;
                        height: 32px;
                        background: #ffffff;
                        border-radius: 5px;

                        /deep/ .el-input {
                            width: 180px;
                            height: 32px;
                        }

                        /deep/ .el-input__inner {
                            padding: 0 10px;
                            box-sizing: border-box;
                            height: 32px;
                            background-color: rgba(255, 255, 255, 0);
                        }

                        /deep/ .el-input__inner::-webkit-input-placeholder {
                            font-size: 14px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #cacaca;
                            line-height: 32px;
                        }

                        /deep/ .el-select .el-input.is-focus .el-input__inner {
                            border-color: rgba(217, 217, 217, 1);
                        }
                    }
                }
            }

            .account-first-button {
                width: 100%;
                height: 36px;
                border-radius: 10px;
                display: flex;
                align-items: center;
                margin-top: 27px;

                .account-first-button-left,
                .account-first-button-right {
                    text-align: center;
                    width: 110px;
                    height: 36px;
                    background: #222222;
                    border-radius: 10px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #ffffff;
                    line-height: 36px;
                    cursor: pointer;
                }

                .account-first-button-right {
                    background: #f4f5f9;
                    color: #999999;
                    margin-left: 10px;
                }
            }
        }
    }

    .account-second {
        background: #ffffff;
        box-shadow: 0px 0px 10px 0px #edeff7;
        border-radius: 10px;
        margin-top: 24px;
        padding: 24px;
        box-sizing: border-box;

        .account-second-div {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 24px;

            .account-second-div-left {
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 600;
                color: #222222;
            }

            .account-second-div-right {
                display: flex;
                align-items: center;
                justify-content: center;

                .account-second-div-right-refresh {
                    width: 70px;
                    height: 36px;
                    border-radius: 10px;
                    border: 1px solid rgba(34, 34, 34, 0.4);
                    text-align: center;
                    line-height: 36px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #222222;
                    cursor: pointer;
                }

                .account-second-div-right-derive {
                    width: 110px;
                    height: 36px;
                    background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
                    border-radius: 10px;
                    margin-left: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;

                    .account-second-div-right-derive-img {
                        width: 12px;
                        height: 12px;
                    }

                    .account-second-div-right-derive-text {
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #ffffff;
                        margin-left: 8px;
                    }
                }
            }
        }

        .account-second-table {
            /deep/ .el-table thead {
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 600;
                color: #333333;
                background: #d8d8d8;
            }

            /deep/ .el-table td.el-table__cell div {
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 400;
            }

            /deep/ .el-table tr {
                height: 46px;
            }

            /deep/ .el-table__empty-text {
                line-height: 0;
            }

            /deep/ .el-table__cell {
                vertical-align: top;
            }

            .empty-block {
                margin-top: 62px;
                padding-bottom: 40px;

                .empty-block-img {
                    width: 130px;
                    height: 130px;
                    margin: 0 auto;
                }

                .empty-block-text {
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #999999;
                    margin-top: 10px;
                    height: 17px;
                    line-height: 17px;
                }
            }

            .table-operation {
                display: flex;
                width: 100%;
                height: 100%;
                align-items: center;

                .table-operation-left {
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #2aa4ff;
                    text-decoration: underline;
                    cursor: pointer;
                    margin-right: 10px;
                }
            }
        }

        .account-second-Pagination {
            height: 88px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-end;

            /deep/ .el-pagination .btn-prev {
                padding: 0;
                width: 32px;
                height: 32px;
                background: #ffffff;
                border-radius: 2px;
                border: 1px solid #d9d9d9;
                margin-right: 8px;
            }

            /deep/ .el-pagination .btn-next {
                padding: 0;
                width: 32px;
                height: 32px;
                background: #ffffff;
                border-radius: 2px;
                border: 1px solid #d9d9d9;
            }

            /deep/ .el-pager li {
                padding: 0;
                width: 32px;
                height: 32px;
                background: #ffffff;
                border-radius: 2px;
                border: 1px solid #d9d9d9;
                line-height: 32px;
                margin-right: 8px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.65);
            }

            /deep/ .el-pager li.active {
                background: #000000;
                color: #ffffff;
            }

            /deep/ .el-input--mini .el-input__inner {
                height: 32px;
            }

            /deep/ .el-input__inner {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.65);
            }
        }
    }

    .examine {
        /deep/ .el-dialog {
            height: 231px;
            width: 394px;
        }

        /deep/ .el-dialog__footer {
            padding: 25px 0;
            box-sizing: border-box;
        }

        .examine-password {
            width: 100%;

            .password {
                display: flex;

                .password-img {
                    width: 56px;
                    height: 56px;
                    margin: 0 auto;
                }
            }

            .title {
                font-size: 18px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                color: rgba(0, 0, 0, 0.85);
                margin: 15px 0 5px;
                text-align: center;
            }

            .text {
                font-size: 14px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.45);
                text-align: center;
            }

        }

        .examine-button {
            display: flex;
            justify-content: center;
            align-content: center;
            margin-top: 30px;

            .examine-button-left,
            .examine-button-right {
                width: 88px;
                height: 32px;
                background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
                border-radius: 10px;
                text-align: center;
                line-height: 32px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
                cursor: pointer;
            }

            .examine-button-right {
                margin-left: 8px;
                border: 1px solid #e9edf4;
                color: rgba(0, 0, 0, 0.65);
                background: #ffffff;
            }
        }
    }

    .password {
        /deep/ .el-dialog {
            width: 404px;
            height: 220px;
        }

        /deep/ .el-dialog__footer {
            padding: 0;
            box-sizing: border-box;
        }

        .password-title {
            height: 56px;
            width: 100%;
            border-bottom: 1px solid #999;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 16px;
            box-sizing: border-box;

            .title {
                font-size: 16px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                color: #222222;
            }

            .img {
                width: 11px;
                height: 10px;
                cursor: pointer;
            }
        }

        .password-block {
            margin-top: 20px;
            text-align: left;
            padding: 0 16px;
            box-sizing: border-box;

            .password-block-title {
                font-size: 12px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #999999;
            }

            .password-block-span {
                font-size: 14px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #222222;
                margin-top: 10px;
            }
        }
    }

    .information {
        /deep/ .el-dialog {
            width: 445px;
        }

        /deep/ .el-dialog__footer {
            padding: 0;
            box-sizing: border-box;
        }

        .information-title {
            height: 56px;
            width: 100%;
            border-bottom: 1px solid #E8E8E8;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 16px;
            box-sizing: border-box;

            .title {
                font-size: 16px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                color: #222222;
            }

            .img {
                width: 11px;
                height: 10px;
                cursor: pointer;
            }
        }

        .information-div {
            .div {
                padding: 20px 24px 6px;
                box-sizing: border-box;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;

                border-bottom: 1px solid #E8E8E8;

                .div-list,
                .div-list1 {
                    width: calc(100% / 3 - 50px);
                    text-align: left;
                    margin-bottom: 14px;

                    .list-title {
                        font-size: 12px;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        color: #999999;
                        line-height: 17px;
                    }

                    .list-value {
                        font-size: 14px;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        color: #222222;
                        line-height: 20px;
                        margin-top: 4px;
                    }

                    .list-img {
                        display: flex;
                        margin-top: 4px;

                        .img1 {
                            width: 150px;
                            height: 149px;
                            background: #F0F0F0;
                            display: flex;
                            justify-content: center;
                            align-items: center;

                            img {
                                width: 150px;
                                height: 115px;
                                object-fit: cover;
                            }
                        }
                    }
                }

                .div-list1 {
                    width: 100%;
                }
            }
        }

        .information-block {
            padding: 21px 23px;
            box-sizing: border-box;
            text-align: left;

            .block-title {
                font-size: 14px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                color: #222222;
            }

            .block-select {
                margin-top: 12px;

                .select-title {
                    font-size: 12px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 600;
                    color: #505050;
                }

                .select {
                    margin-top: 5px;

                    /deep/ .el-select {
                        width: 100%;
                    }
                }
            }

            .block-text {
                font-size: 12px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #999999;
                margin-top: 14px;
            }

            .block-textarea {
                height: 206px;
                background: #FFFFFF;
                border-radius: 5px;
                border: 1px solid #D9D9D9;
                margin-top: 5px;
                padding: 0 12px;
                box-sizing: border-box;

                /deep/ .el-textarea__inner:hover {
                    border: 0;
                }

                /deep/ .el-textarea__inner {
                    border: 0;
                    resize: none;
                    height: 100px;
                }

                .textarea-display {
                    .display-upload {
                        display: flex;

                        /deep/ .el-upload--picture-card {
                            width: 100%;
                            height: 100px;
                            display: flex;
                            align-items: center;
                            border: 1px solid rgba(255, 255, 255, 0);
                        }

                        /deep/ .el-upload--picture-card:hover {
                            border-color: rgba(255, 255, 255, 0);
                        }

                        /deep/ .el-upload-list--picture-card .el-upload-list__item {
                            width: 84px;
                            height: 84px;
                            margin: 0;
                        }

                        .display-upload-list {
                            width: 84px;
                            height: 84px;
                            margin-right: 24px;
                            position: relative;
                            border: 1px solid rgba(255, 255, 255, 0);

                            .display-upload-list-img {
                                width: 84px;
                                height: 84px;
                            }
                        }

                        .display-upload-list:last-child {
                            margin-right: 0;
                        }

                        .display-upload-detele {
                            position: absolute;
                            top: -10px;
                            right: -10px;
                            width: 20px;
                            height: 20px;
                        }
                    }
                }
            }
        }

        .information-button {
            width: 100%;
            height: 52px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding: 0 16px;
            box-sizing: border-box;
            border-top: 1px solid #d9d9d9;
            margin-top: 25px;

            .button-reset,
            .button-confirm {
                width: 65px;
                height: 32px;
                background: #ffffff;
                border-radius: 10px;
                border: 1px solid #e9edf4;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #555555;
                text-align: center;
                line-height: 32px;
                cursor: pointer;
            }

            .button-confirm {
                background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
                color: #ffffff;
                margin-left: 8px;
            }
        }

    }


}
</style>
